import React from 'react';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { dynamicStylingHelper, useServicesContext } from '@oneaudi/vtp-shared';
import { ContentService } from '@oneaudi/content-service';
import { OneCMSContent } from '../../../types/oneCMS';
import { TextButton } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';
import { SwitchNCUCWrapper, SwitchButtons, SubHeadText } from '../styles/SwitchNCUC.styles';
import { useI18n } from '@oneaudi/i18n-context';
import { trackSwitchNCUC } from '../../../tracking/quickFiltersTracking';

interface SwitchNCUCProps {}

// eslint-disable-next-line no-empty-pattern
export const SwitchNCUC: React.FC<SwitchNCUCProps> = () => {
  const audiContentService = useServicesContext().getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;
  const { isNewCarsPage, plpOtherCarsPagePathname } = audiContentService.getContent()
    .fields as OneCMSContent;
  const buttonSwitchHeadline = useI18n({
    id: `nemo.sc.plp.buttonSwitchHeadline`,
    defaultMessage: 'Type',
  });
  const newCarsButtonLabel = useI18n({
    id: `nemo.sc.plp.newCarsButtonLabel`,
    defaultMessage: 'New cars',
  });
  const usedCarsButtonLabel = useI18n({
    id: `nemo.sc.plp.usedCarsButtonLabel`,
    defaultMessage: 'Used cars',
  });

  return (
    <SwitchNCUCWrapper>
      <SubHeadText
        variant={{ type: 'copy', order: dynamicStylingHelper('2', '1'), style: 'short' }}
        margin={[0, 0, SYS_SPACE_FIXED_150, 0]}
      >
        {buttonSwitchHeadline}
      </SubHeadText>
      <SwitchButtons>
        <TextButton
          variant={isNewCarsPage ? 'primary' : 'secondary'}
          size="sm"
          href={isNewCarsPage ? undefined : plpOtherCarsPagePathname}
          data-testid="newStockCTA"
          onClick={() =>
            trackSwitchNCUC(
              trackingService,
              'vtp quick filter - go to new cars platform',
              newCarsButtonLabel,
              buttonSwitchHeadline
            )
          }
        >
          {newCarsButtonLabel}
        </TextButton>
        <TextButton
          variant={isNewCarsPage ? 'secondary' : 'primary'}
          size="sm"
          href={isNewCarsPage ? plpOtherCarsPagePathname : undefined}
          data-testid="usedStockCTA"
          onClick={() =>
            trackSwitchNCUC(
              trackingService,
              'vtp quick filter - go to used cars platform',
              usedCarsButtonLabel,
              buttonSwitchHeadline
            )
          }
        >
          {usedCarsButtonLabel}
        </TextButton>
      </SwitchButtons>
    </SwitchNCUCWrapper>
  );
};
